import CssBaseline from "@mui/material/CssBaseline";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";

import { theme } from "./material-ui/theme";

export { theme };
export { TAB_INDICATOR_SPACING } from "./material-ui/components/tab";

export type {
  CustomPaletteKey,
  ColorName,
  ColorNameWithBackground,
} from "./options/palette";

export interface ThemeProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProps) {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
}
